import { isMobile } from 'util/screen';
import { RECOMMENDATIONS_VALUE } from './constants';

export const mapPropsToValues = ({
  selectedCategory = {},
  giftParams = {},
  withRecommendations
}) => ({
  selectedCategory: selectedCategory.id || '',
  filterCategory:
    withRecommendations && !giftParams.category && isMobile()
      ? RECOMMENDATIONS_VALUE
      : giftParams.category
});
